class HideLink {
    constructor() {
        this.run();
    }
    run() {
        document.querySelectorAll('[data-hide-link-src]').forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelectorAll('[data-hide-link-dst]').forEach((link2) => {
                    link2.click();
                });
            });
        });
    }
}

export default HideLink